<template>
  <div>
    <Table :columns="columns" :data="tableData"></Table>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import filter from '@/api/filter';
import { common, pageTool } from '@/api/mixins';
export default {
  mixins: [common, pageTool],
  props: ['type'],
  data() {
    return {
      columns: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'platformActivityName',
          minWidth: 350,
          render(h, params) {
            let { platformActivityName, platformActivityStarTime, platformActivityEndTime } = params.row;
            return (
              <span>
                {platformActivityName}({filter.filterTime(platformActivityStarTime, 'YYYY-MM-DD')}到{filter.filterTime(platformActivityEndTime, 'YYYY-MM-DD')})
              </span>
            );
          }
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '最新状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执回销日期',
          align: 'center',
          key: 'receiptDate',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filter.filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filter.filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{filter.filterTime(hesitateDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 120
        },
        {
          title: '交费期',
          key: 'payLimit',
          align: 'center',
          render(h, params) {
            return <span>{params.row.payLimit ? params.row.payLimit + '年' : ''}</span>;
          },
          minWidth: 130
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            let commissionIndex = params.row.commissionIndex;
            return <span>{commissionIndex ? commissionIndex : '-'}</span>;
          }
        },
        {
          title: '交费期次',
          align: 'center',
          key: 'commissionPeriods',
          minWidth: 100
        },
        {
          title: '实收保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用归属',
          align: 'center',
          key: 'owerName',
          minWidth: 130
        },
        {
          title: '职级',
          align: 'center',
          key: 'rankName',
          minWidth: 150,
          render(h, params) {
            let rankName = params.row.rankName;
            return <span>{rankName ? rankName : '-'}</span>;
          }
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 100,
          render(h, params) {
            const commission = params.row.commission;
            return <span>{commission ? commission + '%' : '-'}</span>;
          }
        },
        {
          title: '费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 120
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 120
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        }
      ],
      tableData: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = {
        reportId: this.$route.query.reportId,
        type: 5,
        userId: this.$route.query.userId,
        pageSize: this.pageSize,
        pageNo: this.pageNum
      };
      this.$http({
        url: '/buz/userSalaryDetails/getDetailWithSelf',
        type: 'POST',
        data
      }).then(res => {
        this.tableData = res.data;
        this.total = res.total;
        this.$emit('showTable', this.total == 0 ? false : true, 5);
      });
    }
  }
};
</script>

<style></style>
